var _pegPriceTypesNames;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export var pegPriceType = {
  last: '1',
  bid: '2',
  ask: '3'
};

/**
 * context.t('Last')
 * context.t('Bid')
 * context.t('Ask')
 */

export var pegPriceTypesNames = (_pegPriceTypesNames = {}, _defineProperty(_pegPriceTypesNames, pegPriceType.last, 'Last'), _defineProperty(_pegPriceTypesNames, pegPriceType.bid, 'Bid'), _defineProperty(_pegPriceTypesNames, pegPriceType.ask, 'Ask'), _pegPriceTypesNames);